export default __webpack_public_path__ + "static/media/2.e1c8ddae.jpg";